export default __webpack_public_path__ + "static/media/FMS500-StCAN.def6bb9e.png";